export default __webpack_public_path__ + "static/media/htb-alejandro.3d6c43bf.jpg";